//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


export default {
  name: 'Lysk_main',
  data () {
    return {
      infoTab:0
    }
  },

  methods: {
    
  }
}
